import apiClient from '../apiClient';
import { POST_CHANGE_PASSWORD } from '../apiUrl';

const postChangePassword = data => {
  return apiClient.post(POST_CHANGE_PASSWORD, data);
};

export default postChangePassword;
